import { render, staticRenderFns } from "./drawerRight.vue?vue&type=template&id=2dedd2bb&scoped=true&"
import script from "./drawerRight.vue?vue&type=script&lang=js&"
export * from "./drawerRight.vue?vue&type=script&lang=js&"
import style0 from "./drawerRight.vue?vue&type=style&index=0&id=2dedd2bb&prod&scoped=true&lang=css&"
import style1 from "./drawerRight.vue?vue&type=style&index=1&id=2dedd2bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dedd2bb",
  null
  
)

export default component.exports